import React from 'react';
import { isEmbeddedAuthenticatedSession, isEmbeddedSessionHost } from './sessionContract';

export interface HostAuthProps {
  platformSessionId?: string | null;
  platformUser?: { user_id: string | number; [k: string]: unknown } | null;
  onAuthRequired?: () => void;
}

const VirtualAuthContext = React.createContext<HostAuthProps>({});

export function useHostAuth(): HostAuthProps {
  return React.useContext(VirtualAuthContext);
}

export function isEmbeddedWithAuth(props: HostAuthProps): boolean {
  return isEmbeddedAuthenticatedSession(props);
}

/** True when virtual-web is loaded inside platform-web (has onAuthRequired), regardless of session. */
export function isEmbedded(props: HostAuthProps): boolean {
  return isEmbeddedSessionHost(props);
}

export function isHostAuthenticated(props: HostAuthProps): boolean {
  return isEmbeddedWithAuth(props);
}

export function VirtualAuthProvider({
  value,
  children,
}: {
  value: HostAuthProps;
  children: React.ReactNode;
}) {
  return (
    <VirtualAuthContext.Provider value={value}>
      {children}
    </VirtualAuthContext.Provider>
  );
}
